import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { SelectV2Desktop as BaseSelect } from '@alfa-bank/site-select-v2/desktop';

import type { IDeps } from './models/common';
import type { TSelectDesktop } from './models/desktop';
import { Select as Component } from './select';

export const FormSelectDesktop = createWidget<IDeps, TSelectDesktop>({
    Field,
    BaseSelect,
})(Component);
